<template>
  <div>
    <div class="text-base font-medium text-sky-500 mb-0.5">
      <router-link class="hover:underline" :to="to">{{ linkLabel }}</router-link>
    </div>
    <div class="text-sm text-neutral-600 leading-normal">{{ description }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { type RouteLocationAsPathGeneric, type RouteLocationAsRelativeGeneric } from "vue-router";

export default defineComponent({
  name: "LandingCardLinkSection",
  props: {
    linkLabel: {
      type: String,
      required: true,
    },
    to: {
      type: Object as PropType<string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric>,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
  },
});
</script>
